import type { PrimitiveTableColumn } from '@pbt/pbt-ui-components'

import i18n from '~/locales/i18n'

import AppointmentEventTypeFilter from './AppointmentEventTypeFilter'
import AppointmentTypeClientSchedulingFilter from './AppointmentTypeClientSchedulingFilter'
import AppointmentTypeColorFilter from './AppointmentTypeColorFilter'
import AppointmentTypeEnabledFilter from './AppointmentTypeEnabledFilter'
import { Filters, Sortings } from './utils'

/** V1 layout: 6 columns, no drop-off. Used when APPOINTMENT_CONFIG_LAYOUT_V2 is off. */
export const getAppointmentConfigurationColumnsV1 =
  (): PrimitiveTableColumn[] => [
    {
      label: i18n.t('Common:COLOR'),
      filter: Filters.COLOR,
      FilterComponent: AppointmentTypeColorFilter,
      width: 2,
    },
    {
      label: i18n.t('Common:TYPE_ONE'),
      filter: Filters.EVENT_TYPE_IDS,
      FilterComponent: AppointmentEventTypeFilter,
      width: 2.5,
    },
    {
      label: i18n.t('Common:DISPLAY_NAME'),
      prop: 'procedureShortDescription',
      width: 3.5,
      sorting: Sortings.ORDER_ONLY_BY_NAME_ASCENDING,
    },
    {
      label: i18n.t('Common:DURATION'),
      sublabel: i18n.t('Time:LABEL.HOURS_MINUTES'),
      width: 2,
    },
    {
      label: i18n.t('Common:CLIENT_SCHEDULING'),
      filter: Filters.ONLINE_SCHEDULING_ENABLED,
      FilterComponent: AppointmentTypeClientSchedulingFilter,
      width: 2,
    },
    {
      label: i18n.t('Common:ACTIVE_ONE'),
      filter: Filters.ENABLED,
      FilterComponent: AppointmentTypeEnabledFilter,
      width: 2,
    },
  ]
